import React, { useEffect, useState } from 'react';
import { Modal, Tabs, Tab, Form, Stack } from 'react-bootstrap';
import { Button, CountDown } from 'lb-components';
import classes from './RecoveryModal.module.css';
import { Api, Hook, useTranslation } from 'lb-store';
import _ from 'lodash';
import { useChangePassword } from 'lb-store/src/hooks';
import Config from 'lb-store/src/config/config';

const Captcha = ({ counter, setCounter }) => {
  return (
    <img
      src={`${Config.Captcha}${counter}`}
      style={{ width: '100%' }}
      alt='captcha'
      onClick={() => setCounter(counter + 1)}
    />
  );
};

export const RecoveryModal = ({
  onSuccess,
  onCancel,
  initialTab,
  ...props
}) => {
  const { t } = useTranslation();
  const Alert = Hook.UseAlert();
  const changePasswordHook = useChangePassword();
  const [currentTab, setCurrentTab] = useState(initialTab);
  const [loader, setLoader] = useState(false);
  const [securityCode, setSecurityCode] = useState('');
  const [pid, setPid] = useState('');
  const [username, setUsername] = useState('');
  const [phone, setPhone] = useState('');
  const [smsCode, setSmsCode] = useState('');
  const [showSmsCode, setShowSmsCode] = useState(false);
  const [showSecurityCode, setShowSecurityCode] = useState(true);
  const [resend, setResend] = useState(false);
  const [disableField, setDisableField] = useState(false);
  const [timer, setTimer] = useState(0);
  const [errors, setErrors] = useState({
    username: '',
    pid: '',
    phone: '',
    smsCode: '',
    securityCode: '',
  });
  const [counter, setCounter] = useState(0);
  useEffect(() => {
    setPhone('');
    setPid('');
    setUsername('');
    setSecurityCode('');
    setSmsCode('');
    setShowSecurityCode(true);
    setShowSmsCode(false);
  }, [currentTab]);
  const onRecoveryUsername = (sendSmsCode = true, resend = false) => {
    let params;
    if (showSmsCode && sendSmsCode) {
      setDisableField(true);
      let err = {};
      if (!pid) {
        err['pid'] = t('გთხოვთ, შეავსოთ ველი');
      }

      if (!phone) {
        err['phone'] = t('გთხოვთ, შეავსოთ ველი');
      }

      if (_.size(err) > 0) {
        setErrors({ ...errors, ...err });
        return;
      }
      params = {
        act: 'checkSmsCode',
        type: 'username',
        code: smsCode,
      };
    } else {
      setDisableField(false);
      let err = {};
      if (!pid) {
        err['pid'] = t('გთხოვთ, შეავსოთ ველი');
      }

      if (!phone) {
        err['phone'] = t('გთხოვთ, შეავსოთ ველი');
      }

      if (!securityCode) {
        err['securityCode'] = t('გთხოვთ, შეავსოთ ველი');
      }

      if (_.size(err) > 0) {
        setErrors({ ...errors, ...err });
        return;
      }
      setErrors({
        username: '',
        pid: '',
        phone: '',
        smsCode: '',
        securityCode: '',
      });
      params = {
        pid: pid,
        phone: phone,
        act: 'sms',
        resource: 'username',
        code: smsCode,
        capcha: resend ? '' : securityCode,
      };
    }
    Api.Guest.Recovery(params, loader).then((response) => {
      if (response.status) {
        if (response?.data?.code === 'sms') {
          setShowSecurityCode(false);
          setResend(true);
          setTimer(response?.data?.left);
          setShowSmsCode(true);
          Alert.open({
            message: response.data.desc,
          });
        } else {
          onCancel();
          Alert.open({
            message: `თქვენი მომხმარებლის სახელია: ${response.data?.users[0]}`,
          });
        }
      } else {
        Alert.open({
          message: response.data.desc,
        });
      }
    });
  };
  const onRecoveryPassword = (sendSmsCode = true) => {
    let params;
    if (showSmsCode && sendSmsCode) {
      setDisableField(true);
      let err = {};
      if (!pid) {
        err['pid'] = t('გთხოვთ, შეავსოთ ველი');
      }
      if (!phone) {
        err['phone'] = t('გთხოვთ, შეავსოთ ველი');
      }
      if (_.size(err) > 0) {
        setErrors({ ...errors, ...err });
        return;
      }
      params = {
        act: 'checkSmsCode',
        type: 'password',
        code: smsCode,
      };
    } else {
      setDisableField(false);
      let err = {};

      if (!username) {
        err['username'] = t('გთხოვთ, შეავსოთ ველი');
      }
      if (!pid) {
        err['pid'] = t('გთხოვთ, შეავსოთ ველი');
      }
      if (!phone) {
        err['phone'] = t('გთხოვთ, შეავსოთ ველი');
      }
      if (!securityCode) {
        err['securityCode'] = t('გთხოვთ, შეავსოთ ველი');
      }
      if (_.size(err) > 0) {
        setErrors({ ...errors, ...err });
        return;
      }
      setErrors({
        username: '',
        pid: '',
        phone: '',
        smsCode: '',
        securityCode: '',
      });
      params = {
        username: username,
        pid: pid,
        phone: phone,
        capcha: securityCode,
        act: 'sms',
        resource: 'password',
        code: smsCode,
      };
    }
    Api.Guest.Recovery(params, loader).then((response) => {
      if (response.status) {
        if (response?.data?.code === 'sms') {
          setShowSecurityCode(false);
          setResend(true);
          setTimer(response?.data?.left);
          setShowSmsCode(true);
          Alert.open({
            message: response.data.desc,
          });
        } else {
          onCancel();
          changePasswordHook.open({
            onSuccess: () => console.log('success'),
          });
        }
      } else {
        Alert.open({
          message: response.data.desc,
        });
      }
    });
  };

  return (
    <Modal contentClassName={classes.modal} onHide={onCancel} {...props}>
      <Modal.Body className={classes.body}>
        <Tabs
          activeKey={currentTab}
          onSelect={(k) => setCurrentTab(k)}
          className={classes.tabs}
        >
          <Tab eventKey='password' title={t('პაროლის აღდგენა')}>
            <Form
              className={classes.form}
              onSubmit={(e) => {
                e.preventDefault();
                onRecoveryPassword();
              }}
            >
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('მომხმარებლის სახელი')}</Form.Label>
                <Form.Control
                  disabled={disableField}
                  isInvalid={errors.username !== ''}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.username}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('პირადი ნომერი')}</Form.Label>
                <Form.Control
                  disabled={disableField}
                  isInvalid={errors.pid !== ''}
                  value={pid}
                  onChange={(e) => setPid(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.pid}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('მობილური ნომერი')}</Form.Label>
                <Form.Control
                  disabled={disableField}
                  isInvalid={errors.phone !== ''}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.phone}
                </Form.Control.Feedback>
              </Form.Group>
              {showSecurityCode && (
                <Form.Group className={classes.formGroup}>
                  <Form.Label>{t('დამცავი კოდი')}</Form.Label>
                  <Stack
                    direction={'horizontal'}
                    style={{
                      display: 'flex',
                      alignItems: 'stretch',
                    }}
                    gap={1}
                  >
                    <div
                      style={{
                        maxWidth: '50%',
                        width: '100px',
                        marginBottom: errors.securityCode !== '' ? '2rem' : 0,
                        display: 'flex',
                        backgroundColor: '#424242',
                        cursor: 'pointer',
                      }}
                    >
                      {/*<img
                        src={`${Config.Captcha}${counter}`}
                        style={{ width: '100%' }}
                        alt='captcha'
                        onClick={() => setCounter(counter + 1)}
                      />*/}
                      <Captcha counter={counter} setCounter={setCounter}/>
                    </div>
                    <Stack
                      direction={'vertical'}
                      style={{
                        display: 'flex',
                        alignItems: 'stretch',
                      }}
                      gap={1}
                    >
                      <Form.Control
                        type={'number'}
                        style={{ flex: 1 }}
                        isInvalid={errors.securityCode !== ''}
                        value={securityCode}
                        onChange={(e) => {
                          setSecurityCode(e.target.value);
                          setErrors({ ...errors, securityCode: '' });
                        }}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.securityCode}
                      </Form.Control.Feedback>
                    </Stack>
                  </Stack>
                </Form.Group>
              )}
              {showSmsCode && (
                <Form.Group className={classes.formGroup}>
                  <Form.Label>{t('სმს კოდი')}</Form.Label>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      type={'number'}
                      isInvalid={errors.smsCode !== ''}
                      value={smsCode}
                      onChange={(e) => {
                        setSmsCode(e.target.value);
                        setErrors({ ...errors, smsCode: '' });
                      }}
                    />

                    {resend && (
                      <div
                        style={{
                          position: 'absolute',
                          right: 2,
                          top: '50%',
                          transform: 'translateY(-50%)',
                        }}
                      >
                        <CountDown
                          onComplete={() => {
                            setResend(false);
                            setErrors({ ...errors, smsCode: '' });
                          }}
                          Duration={timer}
                          Colors={['#ffca2c']}
                          ColorsTime={[0]}
                          BackgroundColor={'#373940'}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div>
                      {!resend && (
                        <Form.Label
                          style={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            onRecoveryPassword(false);
                            setSmsCode('');
                            setErrors({ ...errors, smsCode: '' });
                          }}
                        >
                          {t('თავიდან გაგზავნა')}
                        </Form.Label>
                      )}
                    </div>
                    <div style={{ color: 'red', fontSize: '0.875em' }}>
                      {errors.smsCode}
                    </div>
                  </div>
                </Form.Group>
              )}
              <Stack
                direction={'horizontal'}
                className={classes.buttonsContainer}
                gap={4}
              >
                <Button variant={'success'} type='submit'>
                  {t('აღდგენა')}
                </Button>
                <Button variant={'secondary'} onClick={onCancel}>
                  {t('გაუქმება')}
                </Button>
              </Stack>
            </Form>
          </Tab>
          <Tab eventKey='username' title={t('მომხმარებლის აღდგენა')}>
            <Form
              className={classes.form}
              onSubmit={(e) => {
                e.preventDefault();
                onRecoveryUsername();
              }}
            >
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('პირადი ნომერი')}</Form.Label>
                <Form.Control
                  disabled={disableField}
                  isInvalid={errors.pid !== ''}
                  value={pid}
                  onChange={(e) => setPid(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.pid}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className={classes.formGroup}>
                <Form.Label>{t('მობილური ნომერი')}</Form.Label>
                <Form.Control
                  disabled={disableField}
                  isInvalid={errors.phone !== ''}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.pid}
                </Form.Control.Feedback>
              </Form.Group>
              {showSecurityCode && (
                <Form.Group className={classes.formGroup}>
                  <Form.Label>{t('დამცავი კოდი')}</Form.Label>
                  <Stack
                    direction={'horizontal'}
                    style={{
                      display: 'flex',
                      alignItems: 'stretch',
                    }}
                    gap={1}
                  >
                    <div
                      style={{
                        maxWidth: '50%',
                        width: '100px',
                        marginBottom: errors.securityCode !== '' ? '2rem' : 0,
                        display: 'flex',
                        backgroundColor: '#424242',
                        cursor: 'pointer',
                      }}
                    >
                      {/*<img
                        src={`${Config.Captcha}&${counter}`}
                        style={{ width: '100%' }}
                        alt='captcha'
                        onClick={() => setCounter(counter + 1)}
                      />*/}
                      <Captcha counter={counter} setCounter={setCounter}/>
                    </div>
                    <Stack
                      direction={'vertical'}
                      style={{
                        display: 'flex',
                        alignItems: 'stretch',
                      }}
                      gap={1}
                    >
                      <Form.Control
                        type={'number'}
                        style={{ flex: 1 }}
                        isInvalid={errors.securityCode !== ''}
                        value={securityCode}
                        onChange={(e) => {
                          setSecurityCode(e.target.value);
                          setErrors({ ...errors, securityCode: '' });
                        }}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {errors.securityCode}
                      </Form.Control.Feedback>
                    </Stack>
                  </Stack>
                </Form.Group>
              )}
              {showSmsCode && (
                <Form.Group className={classes.formGroup}>
                  <Form.Label>{t('სმს კოდი')}</Form.Label>
                  <div style={{ position: 'relative' }}>
                    <Form.Control
                      type={'number'}
                      isInvalid={errors.smsCode !== ''}
                      value={smsCode}
                      onChange={(e) => {
                        setSmsCode(e.target.value);
                        setErrors({ ...errors, smsCode: '' });
                      }}
                    />

                    {resend && (
                      <div
                        style={{
                          position: 'absolute',
                          right: 2,
                          top: '50%',
                          transform: 'translateY(-50%)',
                        }}
                      >
                        <CountDown
                          onComplete={() => {
                            setResend(false);
                            setErrors({ ...errors, smsCode: '' });
                          }}
                          Duration={timer}
                          Colors={['#ffca2c']}
                          ColorsTime={[0]}
                          BackgroundColor={'#373940'}
                        />
                      </div>
                    )}
                  </div>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div>
                      {!resend && (
                        <Form.Label
                          style={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            onRecoveryUsername(false, true);
                            setSmsCode('');
                            setErrors({ ...errors, smsCode: '' });
                          }}
                        >
                          {t('თავიდან გაგზავნა')}
                        </Form.Label>
                      )}
                    </div>
                    <div style={{ color: 'red', fontSize: '0.875em' }}>
                      {errors.smsCode}
                    </div>
                  </div>
                </Form.Group>
              )}
              <Stack
                direction={'horizontal'}
                style={{ justifyContent: 'flex-end' }}
                gap={4}
              >
                <Button variant={'success'} type='submit'>
                  {t('აღდგენა')}
                </Button>
                <Button variant={'secondary'} onClick={onCancel}>
                  {t('გაუქმება')}
                </Button>
              </Stack>
            </Form>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

/*RecoveryModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  initialTab: PropTypes.oneOf(['password', 'username']),
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
};*/
RecoveryModal.defaultProps = {
  show: true,
  centered: true,
  initialTab: 'username',
  onCancel: () => console.log('success'),
  onSuccess: () => console.log('success')
};
